import type React from 'react';

import MenuItem from '@mui/material/MenuItem';

import DateTimeFormat from 'components/date/DateTimeFormat';
import TMXSelect, { type MuiSelectProps } from 'components/selectors/tmxSelector/TMXSelect';
import { SelectItemLabel } from 'components/typography/Typography';
import { type Format } from 'utils/dateTimeUtils';

const DEFAULT_TIME_FORMAT: Format = { dateStyle: 'full' };

interface TMXTournamentDatesSelectProps {
  dates?: string[];
  dateFormat?: Format;
  initialValue?: string;
  placeholder?: string;
}

type TournamentDatesSelectProps = MuiSelectProps & TMXTournamentDatesSelectProps;

const TournamentDatesSelect: React.FC<React.PropsWithChildren<TournamentDatesSelectProps>> = ({
  dateFormat = DEFAULT_TIME_FORMAT,
  dates,
  initialValue,
  placeholder,
  ...props
}) => {
  return (
    <TMXSelect displayEmpty={!!placeholder} {...props} defaultValue={placeholder ? '' : initialValue}>
      {!!placeholder && (
        <MenuItem disabled value="">
          {placeholder}
        </MenuItem>
      )}
      {(dates || []).map((date, ind) => (
        <MenuItem key={ind} value={date}>
          <SelectItemLabel>
            <DateTimeFormat day="2-digit" format={dateFormat} month="short" value={date} year="numeric" />
          </SelectItemLabel>
        </MenuItem>
      ))}
    </TMXSelect>
  );
};

export default TournamentDatesSelect;
